import { useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import { usePostJson } from "hooks/use-fetch";
import { transformErrors } from "utils/transform-errors";

import ValidationErrors from "screens/shared/validation-errors";

import {
  Alert,
  AlertTitle,
  Button,
  Container,
  FormControl,
  FormHelperText,
  Link,
  OutlinedInput,
  Stack,
  Typography,
} from "components/core";
import NavigationBar from "components/navigation-bar";

const EnterEmail = () => {
  const [email, setEmail] = useState("");
  const [sentEmail, setSentEmail] = useState(null);
  const [errors, setErrors] = useState({});
  const [resendCountdown, setResendCountdown] = useState(0);
  const [login, loginLoading] = usePostJson();

  const timerRef = useRef();
  const history = useHistory();

  const startResendCountdown = () => {
    setInterval(() => {
      setResendCountdown((currentCountdown) => {
        const newCountdown = currentCountdown - 1;

        if (newCountdown === 0) {
          clearInterval(timerRef.current);
        }

        return newCountdown;
      });
    }, 1000);
  };

  const handleBackClick = () => {
    history.push("/");
  };

  const handleEmailChange = (e) => setEmail(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSentEmail(null);
    const response = await login("/dashboard/login", { email });

    if (response.errors) {
      setErrors(transformErrors(response.errors));
    } else {
      setSentEmail(response.email);
      setResendCountdown(30);
      timerRef.current = startResendCountdown();
    }
  };

  return (
    <Container disableGutters maxWidth="xs">
      <NavigationBar onBackClick={handleBackClick} />
      <Stack pb={[2, 3]} pt={[3, 4]} px={[2, 3]} spacing={4}>
        <Stack component="form" spacing={2} onSubmit={handleSubmit}>
          <ValidationErrors errors={errors} />

          {sentEmail && (
            <Alert severity="success">
              <AlertTitle>Check your emails</AlertTitle>
              To log in, tap the link in the email we’ve just sent to{" "}
              {sentEmail}
            </Alert>
          )}
          <FormControl error={!!errors.code}>
            <Typography
              component="label"
              htmlFor="email-input"
              lineHeight="1.5"
              mb={2}
              variant="title"
            >
              Enter your email
            </Typography>
            <OutlinedInput
              autoFocus
              error={!!errors.email}
              id="email-input"
              type="email"
              value={email}
              onChange={handleEmailChange}
            />
            {errors.email && (
              <FormHelperText variant="standard">{errors.email}</FormHelperText>
            )}
          </FormControl>
          <Button
            loading={loginLoading || resendCountdown > 0}
            loadingIndicator={
              resendCountdown > 0 ? `Resend in ${resendCountdown}...` : null
            }
            type="submit"
          >
            Log in
          </Button>
        </Stack>
        <Stack alignItems="center" fontWeight="bold" spacing={1}>
          <Link color="otherGreen.main" href="/after-school/start-apply">
            Sign up to find childcare
          </Link>
          <Link color="otherGreen.main" href="/after-school/nanny/start-apply">
            Become a nanny
          </Link>
        </Stack>
      </Stack>
    </Container>
  );
};

export default EnterEmail;
